import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
// import html2canvas from 'html2canvas';
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";


const DecaySaleView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
 let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(281)); 
console.log(permission);

    axios
      .get(`/decay-sales/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.sale);
         // setApiData(response.data.data.sale);

          console.log(response.data.data.raw);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  

  // const handleDownload = () => {
  //   const element = document.getElementById('printablediv');
    
  //   html2canvas(element).then((canvas) => {
  //     // Convert the canvas to a data URL
  //     const dataURL = canvas.toDataURL();
      
  //     // Create a file name
  //     const fileName = value.invoice_number+'.png';
      
  //     // Save the data URL as a file
  //     saveAs(dataURL, fileName);
  //   });
  // };

  
 
const downloadDecaySaleInvocie = async () => {
   let season_id = localStorage.getItem("season_id");

  $("#loader-image2").removeClass('loader-hide');
  $("#loader-image2").addClass('loader-show');
  axios.get(`/decay-sales/pdf/${season_id+'-'+id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let invoice_number =value?.invoice_number || "" ;
      let customer_name =value?.customer.name || "" ;
      let file_name = customer_name+' '+invoice_number +'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image2").addClass('loader-hide');
      $("#loader-image2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">Decay Sale</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-sales">Decay Sale</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Decay Sale
                    </li>
                  </ul>
                </div>
                <div className="col-sm-2">
                  {/* <button onClick={handleDownload} className="btn btn-primary" >Generate decay sale invoice</button>      */}
                  <div style={{float:"right"}}>
                      <button   onClick={() => downloadDecaySaleInvocie()}   className="btn btn-primary me-1"  > Download Invoice <i className="fa fa-download" /> <img id="loader-image2" className="loader-image loader-hide" src={loader_image}/>  </button>
                    </div>  
                </div>

              </div>
            </div>

            <div className="row">
              <div className="col-md-12 " id="printablediv"> 
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Decay Sale Info</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Invoice Number</th>
                        <td className="p-3">{value.invoice_number}</td>
                      </tr>
                    
                      <tr>
                        <th className="p-3">Date </th>
                        <td className="p-3">
                          {value.date}
                        </td>
                      </tr>
                     {/*  
                      <tr>
                        <th className="p-3">Product</th>
                        <td className="p-3">
                          {value.product_detail ? value.product_detail.name : ""}
                        </td>
                      </tr>
                    <tr>
                        <th className="p-3">Price</th>
                        <td className="p-3">{value.price}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Quantity</th>
                        <td className="p-3">{value.quantity}</td>
                      </tr> */}
                      <tr>
                        <th className="p-3">Total Amount</th>
                        <td className="p-3">{value.total_price}</td>
                      </tr>
                    
                      <tr>
                        <th className="p-3">Customer </th>
                        <td className="p-3">
                          {value.customer ? value.customer.name : ""}
                        </td>
                      </tr>
                    
                      <tr>
                        <th className="p-3">payment Method</th>
                        <td className="p-3">
                          {value.method ? value.method.title : ""}
                        </td>
                      </tr>
                    
                      <tr>
                        <th className="p-3">Payment Status</th>
                        <td className="p-3">
                          {value.status ? value.status.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Note</th>
                        <td className="p-3">{value.note}</td>
                      </tr>
                    </table>
                    <br />
                    <h5 className="card-title">Items:</h5>

                    <table className="table table-bordered">
                      <tr>
                      <th className="p-3">Product</th>
                      <th className="p-3">Price</th>
                      <th className="p-3">Quantity</th>
                     
                      </tr>

                      {value.contents &&
                        value.contents.map((item, indx) => (
                          <tr key={item.product_name || indx}>
                          <td className="p-3">{item.product_name}</td>
                       
                          <td className="p-3">{item.price}</td>
                         
                          <td className="p-3">{item.quantity}</td>
                         
                          </tr>
                        ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </>
  );
};
export default DecaySaleView;
